<template>
<div class="rights">
  <div class="topppp-o">
    <p class="title">顾客信息</p>
    <ul class="gkxx2">
      <li>{{csData.CustomerName?csData.CustomerName:'-'}}</li>
      <li><span v-if="csData.CustomerGender">{{csData.CustomerGender == '0' ? '女':'男'}}</span> <span v-if="!csData.CustomerGender">-</span></li>
      <li>{{csData.CustomerBirthday}}</li>
      <li>{{csData.CustomerAge}}岁</li>
      <li>{{csData.CustomerTel?csData.CustomerTel:'-'}}</li>
      <li><img src="../../../../assets/img/xg.png" @click="openxg" alt=""></li>
    </ul>
  </div>
<!--  <ul class="gkxx">-->
<!--    <li>姓名</li>-->
<!--    <li>性别</li>-->
<!--    <li>年龄</li>-->
<!--    <li>联系方式</li>-->
<!--    <li></li>-->
<!--  </ul>-->


  <ul class="tebfn">
    <li @click="teb(0)" :class="idxs == 0 ? 'xz' : ''">就诊记录</li>
    <li @click="teb(1)" :class="idxs == 1 ? 'xz' : ''">销售记录 <span class="sx"></span></li>
    <li @click="teb(2)" :class="idxs == 2 ? 'xz' : ''">预约记录 <span class="sx"></span></li>
    <li @click="teb(3)" :class="idxs == 3 ? 'xz' : ''">积分记录<span class="sx"></span></li>
  </ul>

  <div class="contents">
    <JZJL v-if="idxs == 0"></JZJL>
    <XSJL v-if="idxs == 1"></XSJL>
    <YYJL v-if="idxs == 2"></YYJL>
    <JFJL v-if="idxs == 3"></JFJL>
  </div>


  <el-dialog
      title="修改顾客信息"
      :visible.sync="showxg"
      width="420px">
    <div>
      <div class="upcs">
        <p>姓名</p>
        <el-input class="upcsrs" v-model="dqCs.CustomerName" placeholder="请输入内容"></el-input>
      </div>
      <div class="upcs">
        <p>性别</p>
        <el-radio v-model="dqCs.CustomerGender" label="1">男</el-radio>
        <el-radio v-model="dqCs.CustomerGender" label="0">女</el-radio>
      </div>
      <div class="upcs">
        <p>电话</p>
        <el-input class="upcsrs" v-model="dqCs.CustomerTel" placeholder="请输入内容"></el-input>
      </div>
      <div class="upcs">
        <p>身份证</p>
        <el-input class="upcsrs" v-model="dqCs.CustomerIDCardNo" placeholder="请输入内容"></el-input>
      </div>
      <div class="upcs">
        <p>生日</p>
        <el-date-picker
            style="width: 260px;"
            v-model="dqCs.CustomerBirthday"
            format="yyyy-MM-dd"
            type="date"
            :editable="false"
            placeholder="选择日期">
        </el-date-picker>
      </div>
      <div class="upcs">
        <p>地区</p>
        <el-cascader
            style="width: 260px;"
            :props="{value: 'AreaId', label: 'AreaName', children: 'ListArea'}"
            v-model="ssx"
            :options="options"
           >
        </el-cascader>
      </div>
      <div class="upcs">
        <p>详细地址</p>
        <el-input class="upcsrs" v-model="dqCs.CustomerAddress" placeholder="请输入内容"></el-input>
      </div>
    </div>
    <div style="text-align: center;padding-top: 20px;">
      <el-button @click="showxg = false">取 消</el-button>
      <el-button type="primary"  @click="upCs(1)">确 定</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
export default {
  name: "rights",
  data() {
    return {
      idxs: 0,
      dqCs: {},
      showxg: false,
      sfz: '',
      ssx: '',
      options: []
    }
  },
  computed: {
    csData() {
      return this.$store.state.users.CsUser
    }
  },
  watch: {
    '$store.state.users.CsUser': function (n) {
      if (n) this.dqCs = JSON.parse(JSON.stringify(n))
    }
  },
  created() {
  },
  methods: {
    teb(num) {
      this.idxs = num
    },
    getsf() {
      this._api.publicApi.getAddress()
          .then(res => {
            // console.log(res)
            if (res.GetListResult && res.GetListResult.length) {
              this.options = res.GetListResult
              if (this.cs.CustomerAreaIndex) {
                let idx = this.dqCs.CustomerAreaIndex.split(',')
                this.ssx = [this.options[idx[0]].AreaId, this.options[idx[0]].ListArea[idx[1]].AreaId, this.options[idx[0]].ListArea[idx[1]].ListArea[idx[2]].AreaId]
              }
            }
          })
    },
    upCs() {
      if (!this.dqCs.CustomerName || !this.dqCs.CustomerTel || !this.dqCs.CustomerBirthday) {
        return this.$alert('内容不能为空，请检查！', '提示')
      }
      let log = this.$loading({
        text: '保存中...'
      })
      this._api.userCurdApi.upCs(this.dqCs)
          .then(res => {
            log.close()
            if (res.UpdateResult) {
              this.showxg = false
              this.$store.commit('users/UpCsUser', this.dqCs)
              this.$alert('保存成功！', '提示')
            }else {
              this.$alert('保存失败！', '提示')
            }
          })
    },
    openxg() {
      this.showxg = true
      this.getsf()
    }
  },
  components: {
    JZJL: () => import('./JZJL'),
    YYJL: () => import('@/components/customerDetailss/consultingBooking'),
    XSJL: () => import('@/components/customerDetailss/salesRecord'),
    JFJL: () => import('@/views/accepts/integral/integralJL')
  }
}
</script>

<style scoped lang="scss">
.topppp-o {
  width: 100%;
  display: flex;
  align-items: center;
}
.rights {
  width: calc(100vw - 276px);
  padding: 10px;
  background: #FFFFFF;
  margin-left: 10px;
}
.title {
  padding: 10px 0;
  text-align: left;
  font-size: 17px;
  font-weight: 500;
  color: rgba(56, 56, 56, 1);
  background: #ffffff;
  padding-left: 17px;
  @media (max-width: 768px) {
    font-size: 14px;
  }
}
.gkxx {
  border-radius: 5px;
  background: rgba(245, 245, 245, 1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  li {
    width: calc(25% - 10px);
    font-size: 15px;
    font-weight: 500;
    color: rgba(56, 56, 56, 1);
    padding: 9px 0;
    @media (max-width: 768px) {
      font-size: 13px;
    }
  }
  li:nth-child(5) {width: 40px;}
}
.gkxx2 {
  //margin-top: 10px;
  width: calc(100% - 100px);
  border-radius: 5px;
  background: #ffffff;
  display: flex;
  align-items: center;
  li {
    font-size: 15px;
    padding: 9px 20px;
    font-weight: 500;
    color: rgba(105, 105, 105, 1);
    @media (max-width: 768px) {
      font-size: 12px;
    }
    img {
      width: 25px;
      cursor: pointer;
    }
  }
  li:nth-child(5) {
    display: flex;
    justify-content: start;
  }
}
.tebfn {
  display: flex;
  align-items: center;
  background: rgba(245, 245, 245, 1);
  padding-top: 6px;
  li {
    width: 25%;
    cursor: pointer;
    font-size: 15px;
    font-weight: 500;
    padding: 5px 0 8px 0;
    position: relative;
    @media (max-width: 768px) {
      font-size: 13px;
    }
  }
  .sx {
    display: block;
    width: 1px;
    height: 15px;
    background: rgba(191, 191, 191, 1);
    position: absolute;
    right: 0;
    top: 14px;
  }
  .xz {
    color: rgba(255, 94, 54, 1);
    background: #ffffff;
    border-radius: 10px 10px 0 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -1px 4px  rgba(0, 0, 0, 0.1);
    position: relative;
  }
  .xz::after {
    content: '';
    position: absolute;
    width: 100%;
    background: #ffffff;
    height: 5px;
    bottom: -2px;
    left: 0;
    z-index: 99;
  }
}
.contents {
  width: calc(100% - 10px);
  height: calc(100% - 80px);
  overflow-y: auto;
}
.upcs {
  display: flex;
  align-items: center;
  margin: 20px auto;
  .upcsrs {
    width: 260px;
  }
  p {padding-right: 10px; width: 6em}
}
</style>
